



















































import { Component, Inject, Ref, Vue } from "vue-property-decorator";
import { IClient } from "@/models/clients";
import { IClientProviderData } from "@/models/providers/client";
import ClientProfileFields from "@/components/app/global/client/clientProfileFields.vue";

@Component({
  components: {
    "client-profile-fields": ClientProfileFields,
    "client-emails-component": () =>
      import("@/components/app/global/client/clientEmailsComp.vue"),
    "billable-entities-component": () =>
      import("@/components/app/global/client/billableEntitiesComp.vue"),
    "client-phones-component": () =>
      import("@/components/app/global/client/clientPhonesComp.vue")
  }
})
export default class ClientSettingsView extends Vue {
  @Inject({ from: "clientProvider" })
  public readonly $clientProvider!: () => IClientProviderData;

  @Ref()
  public readonly clientProfileFields!: ClientProfileFields;

  public isFormChanged = false;
  public formIsDisabled = false;
  public isProcessing = false;

  public get clientId(): IClient["id"] {
    return this.$route.params.clientId;
  }

  public get isStaged() {
    return this.$clientProvider().isStaged;
  }

  public get clientCountryCode() {
    return this.$clientProvider().client.location_country_code;
  }

  public mounted() {
    this.$bus.$emit("scrollToTop");
  }
}
